import { render, staticRenderFns } from "./GoodsInfoYbj.vue?vue&type=template&id=3107369f&scoped=true"
import script from "./GoodsInfoYbj.vue?vue&type=script&lang=js"
export * from "./GoodsInfoYbj.vue?vue&type=script&lang=js"
import style0 from "./GoodsInfoYbj.vue?vue&type=style&index=0&id=3107369f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3107369f",
  null
  
)

export default component.exports